<template>
    <div>
      <div class="header">
        <!-- <img src="https://cdn.ellll.com/wxd/wxdlogo.pn" /> -->
        <div style="width: 100px;"></div>
        <span class="title">杜莎管理系统</span>
        <div class="userInfo">
          <span>{{ admin.name }}</span>
          <el-button
            type="text"
            style="padding: 0; color: #6f737a; font-size: 18px"
            @click="loginOut"
            >退出</el-button
          >
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "headBar",
    data() {
      return {
        name: "",
        admin:{},
      };
    },
  
    computed: {
      // name: function () {
      //   let name = localStorage.getItem('name');
      //   return name;
      // },
    },
    mounted() {
      this.admin = JSON.parse(localStorage.getItem("admin"))
      console.log(this.admin.name)
    },
  
    methods: {
      //退出登录
      loginOut() {
        this.$confirm("确定退出吗", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            localStorage.clear();

            this.$router.push({ path: "/" });
          })
          .catch(() => {});
      },
    },
  };
  </script>
  
  <style scoped>
  .header {
    width: 93.75%;
    height: 50px;
    background: #252629;
    padding: 0 3.125%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
  }
  
  .title {
    position: absolute;
    left: 10%;
    color: #fff;
    font-size: 1.4rem;
  }
  .header > img {
    width: 50px;
    height: 50px;
    vertical-align: bottom;
  }
  .userInfo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .userInfo > span {
    margin-right: 40px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
  </style>
  